import { internal, template } from '../../../vendor/elix.js';
import FloatingLabelBaseMixin from './floating-label-base-mixin.js';

function FloatingLabelForFilledInputMixin(Base) {
  
  return class FloatingLabelForFilledInput extends FloatingLabelBaseMixin(Base) {

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          label {
            left: 16px;
            top: 19px;
          }

          label.floating {
            background-color: var(--tp-floating-label-filled-mixin-background-color-floating, var(--tp-floating-label-mixin-background-color));
            left: 12px;
            top: 7px;
          }

          .inputStateContainer.with-leading-slot-contents label:not(.floating) {
            margin-left: 34px;
          }

          .inputStateContainer.with-leading-slot-contents label.floating {
            margin-left: 32px;
          }

          .inputStateContainer:not(.disabled):not(.error).focused label.floating {
            color: var(--tp-floating-label-filled-mixin-font-color-focused);
          }

        </style>
        
        `
      );

    }

  }
}

export default FloatingLabelForFilledInputMixin;
